var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sbl sbl--navigate--box",on:{"click":_vm.onNavigate}},[_c('div',{staticClass:"is-left"},[_vm._t("default")],2),_c('div',{staticClass:"is-right"},[_c('span',[_vm._v(_vm._s(_vm.label))])])])}
var staticRenderFns = []

export { render, staticRenderFns }